import React, { useState } from 'react';
import Sale01 from '../components/sale/Sale01';
import dataFaq from '../assets/fake-data/data-faq'

const categories = [
    { key: 'all', label: 'Semua' },
    { key: 'akun', label: 'Akun & Pendaftaran' },
    { key: 'fitur', label: 'Fitur & Layanan' },
    { key: 'trading', label: 'Trading & Keuangan' },
    { key: 'dukungan', label: 'Komunitas & Dukungan' },
];

function AccordionItem({ item, isOpen, onClick }) {
    return (
        <div className={`faq-item${isOpen ? ' active' : ''}`}>
            <button className="faq-item-header" onClick={onClick}>
                <span className="faq-item-icon">
                    <i className="bx bx-help-circle"></i>
                </span>
                <span className="faq-item-title">{item.title}</span>
                <span className="faq-item-arrow">
                    <i className={`bx ${isOpen ? 'bx-chevron-up' : 'bx-chevron-down'}`}></i>
                </span>
            </button>
            <div className="faq-item-body">
                <div className="faq-item-content">
                    <p>{item.text}</p>
                </div>
            </div>
        </div>
    );
}

function Faq() {
    const [activeCategory, setActiveCategory] = useState('all');
    const [searchQuery, setSearchQuery] = useState('');
    const [openItems, setOpenItems] = useState(
        dataFaq.filter(i => i.show === 'show').reduce((acc, i) => ({ ...acc, [i.id]: true }), {})
    );

    const filteredData = dataFaq.filter(item => {
        const matchCategory = activeCategory === 'all' || item.category === activeCategory;
        const matchSearch = searchQuery === '' ||
            item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.text.toLowerCase().includes(searchQuery.toLowerCase());
        return matchCategory && matchSearch;
    });

    function toggleItem(id) {
        setOpenItems(prev => ({ ...prev, [id]: !prev[id] }));
    }

    return (
        <div>
            <section className="faq-hero">
                <div className="container">
                    <div className="faq-hero-inner">
                        <h1 className="faq-hero-title" data-aos="fade-up">Pertanyaan Umum</h1>
                        <p className="faq-hero-subtitle" data-aos="fade-up" data-aos-delay="100">
                            Temukan jawaban untuk pertanyaan seputar Tradiora
                        </p>
                        <div className="faq-search" data-aos="fade-up" data-aos-delay="200">
                            <i className="bx bx-search"></i>
                            <input
                                type="text"
                                placeholder="Cari pertanyaan..."
                                value={searchQuery}
                                onChange={e => setSearchQuery(e.target.value)}
                            />
                            {searchQuery && (
                                <button className="faq-search-clear" onClick={() => setSearchQuery('')}>
                                    <i className="bx bx-x"></i>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <section className="faq">
                <div className="container">
                    <div className="faq-categories" data-aos="fade-up">
                        {categories.map(cat => (
                            <button
                                key={cat.key}
                                className={`faq-cat-btn${activeCategory === cat.key ? ' active' : ''}`}
                                onClick={() => setActiveCategory(cat.key)}
                            >
                                {cat.label}
                            </button>
                        ))}
                    </div>

                    <div className="faq-list" data-aos="fade-up" data-aos-delay="100">
                        {filteredData.length > 0 ? (
                            filteredData.map((item, index) => (
                                <AccordionItem
                                    key={item.id}
                                    item={item}
                                    isOpen={!!openItems[item.id]}
                                    onClick={() => toggleItem(item.id)}
                                />
                            ))
                        ) : (
                            <div className="faq-empty">
                                <i className="bx bx-search-alt"></i>
                                <h4>Tidak ditemukan</h4>
                                <p>Tidak ada hasil untuk pencarian "{searchQuery}"</p>
                                <button className="faq-empty-reset" onClick={() => { setSearchQuery(''); setActiveCategory('all'); }}>
                                    Reset Filter
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <Sale01 />
        </div>
    );
}

export default Faq;
